import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function Component(props) {
    const { 
        submitBtnTxt = 'Submit',
        deleteBtnTxt = 'Delete',
        cancelBtnTxt = 'Cancel',
        onSubmit,
        onDelete,
        onCancel,
        disabled = false,
        submitDisabled = false,
        hideSubmit,
        hideCancel,
        showDelete
    } = props;

    return (
        <div className="card-footer py-4 formFooter row flex flex-end">
            
            {showDelete && (
                <button type="button" disabled={disabled} className="btn-lg btn-primary px-4 clickable btnDelete" onClick={onDelete}>
                    {deleteBtnTxt}
                </button>
            )}
            {!hideCancel && (
                <button type="button" disabled={disabled} className="px-4 text-muted pl-4 btnCancel py-2 px-5 rounded-full text-gray font-semibold focus:outline-none bg-blue-60 ml-4" onClick={onCancel}>
                    {cancelBtnTxt}
                </button>
            )}
            {!hideSubmit && (
                <button type="button" disabled={disabled || submitDisabled} className="btn-lg btn-primary clickable py-2 px-5 rounded-full text-white flex focus:outline-none bg-blue-60 disabled:opacity-50 ml-4" onClick={onSubmit}>
                    {submitBtnTxt}
                </button>
            )}
            {props.children}
        </div>
    );
}

Component.propTypes = {
    submitBtnTxt: PropTypes.string,
    cancelBtnTxt: PropTypes.string,
    deleteBtnTxt: PropTypes.string,
    onDelete: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    submitDisabled: PropTypes.bool,
    hideSubmit: PropTypes.bool,
    hideCancel: PropTypes.bool,
    showDelete: PropTypes.bool
};

export default Component;